import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { getUserDetails, inactiveUsers, deleteAccount } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function Userdetails() {

    const location = useLocation();
    const extracted = location.pathname.split('/');
    let customer_id = atob(extracted[3]);
    let navigate = useNavigate();
    const timezone = localStorage.getItem('timezone');

    const titleStyle = { background: 'linear-gradient(180deg, #D7C9A1, #D7C9A1)', padding: '5px 20px', borderRadius: '20px' };
    const boxStyle = { border: '2px solid #D7C9A1', padding: '5px 20px', borderRadius: '20px' };

    const [userprofile, setUserProfile] = useState(null);

    // Fetch data from server
    const fetchData = async () => {
        try {
            
            const userReq = {
                user_id: customer_id
            }
            const response = await getUserDetails(userReq);
            if (parseInt(response.code) === 1) {
                setUserProfile(response.data);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading user details, please try again later");
        }
    };

    useEffect(() => {
        $('.image-popup').magnificPopup({
            type: 'image',
            gallery: {
              enabled: true
            }
        });
        fetchData();
    }, []);

    const handleGoBack = () => {
        navigate(-1);
    };

    const getLoginType = (loginType) => {
        if (loginType === 'A') {
            return <label className="label label-black">Apple</label>
        } else if (loginType === 'G') {
            return <label className="label label-warning">Google</label>
        } else {
            return <label className="label label-success">Simple</label>
        }
    };

    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                    <div className="col-lg-7 col-md-6 col-sm-12">
                        <h2>User Details</h2>
                    </div>
                    <div className="col-lg-5 col-md-6 col-sm-12">
                        <ul className="breadcrumb float-md-right">
                            <li className="breadcrumb-item">
                                <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" /> Dashboard{" "}
                                </a>
                            </li>
                            <li className="breadcrumb-item">
                                <a href="/authpanel/users/listing">Users Listing</a>
                            </li>
                            <li className="breadcrumb-item active">
                                <a>User Details</a>
                            </li>
                        </ul>
                    </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row clearfix">
                    <div className="col-lg-12">
                        <div className="row clearfix">
                            <div className="col-lg-12 col-md-12">
                                <div className="card member-card">
                                    <div className="header l-red">
                                        <div className="col-12 text-left">
                                        <a
                                            href="#"
                                            onClick={handleGoBack}
                                            className="btn btn-raised bg-primary waves-effect waves-red text-left"
                                        >
                                            <i className="zmdi zmdi-arrow-left" />
                                        </a>
                                        </div>
                                    </div>
                                    <div className="bg-custom bg-profile  button-color-css" />
                                        <div className="member-img m-t-5">
                                            <img
                                                src={ userprofile ? userprofile.profile_image : '' }
                                                className="rounded-circle"
                                                alt="image"
                                                width="{100}"
                                                height="150px"
                                            />
                                        </div>
                                        <div className="body">
                                            <div className="col-12">
                                                <ul className="list-inline">
                                                    <li>
                                                        <h4 className="m-t-5">{userprofile ? userprofile.first_name : ''} { userprofile ? userprofile.last_name : '' }</h4>
                                                    </li>
                                                </ul>
                                            </div>
                                            <hr />
                                            <div className="card">
                                                <div className="row text-left">
                                                    <div className="col-md-6">
                                                        <div className="card">
                                                            <h4 className="" style={ titleStyle }>
                                                                <b>BASIC INFORMATION</b>
                                                            </h4>
                                                            <hr />
                                                            <div className="p-20" style={ boxStyle }>
                                                                <div className="about-info-p">
                                                                    <strong>Login Method</strong> <br />
                                                                    <p className="text-muted">{userprofile ? getLoginType(userprofile.login_type) : ''}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Currently Trading</strong> <br />
                                                                    <p className="text-muted">{userprofile ? userprofile.dashboard : ''}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Account Code</strong> <br />
                                                                    <p className="text-muted">{userprofile ? userprofile.account_code : ''}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Phone</strong> <br />
                                                                    <p className="text-muted">{userprofile ? `${userprofile.country_code} ${userprofile.phone}` : ''}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Email</strong> <br />
                                                                    <p className="text-muted">{userprofile ? userprofile.email : ''}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Location</strong> <br />
                                                                    <p className="text-muted">{userprofile ? userprofile.addressline : ''}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Timezone</strong> <br />
                                                                    <p className="text-muted">{userprofile ? userprofile.timezone : 'NA'}</p>
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Status</strong> <br />
                                                                    { 
                                                                        userprofile && userprofile.status === 0 ? 
                                                                        <p className="text-muted">
                                                                            <span className="text-success">Active</span>
                                                                        </p> : 
                                                                        <p className="text-muted">
                                                                            <span className="text-danger">Inactive</span>
                                                                        </p>
                                                                    }
                                                                </div>
                                                                <div className="about-info-p">
                                                                    <strong>Created At</strong> <br />
                                                                    <p className="text-muted">{userprofile ? convertUTCToLocal(userprofile.created_at, timezone) : 'NA'}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <h4 className="mb-2" style={ titleStyle }>
                                                            <b>KYC INFORMATION</b>
                                                        </h4>
                                                        <hr />
                                                        <div className="p-20" style={ boxStyle }>
                                                            <div className="about-info-p">
                                                                <strong>KYC Status</strong> <br />
                                                                {
                                                                    userprofile && userprofile.kyc_status === 0 ? 
                                                                    <b>
                                                                        <p className="text-warning">Pending</p>
                                                                    </b> : (userprofile && userprofile.kyc_status === 1) ? 
                                                                    <b>
                                                                        <p className="text-success">Verified</p>
                                                                    </b> : (userprofile && userprofile.kyc_status === 2) ? 
                                                                    <b>
                                                                        <p className="text-success">Requested</p>
                                                                    </b> : 
                                                                    <b>
                                                                        <p className="text-danger">Failed</p>
                                                                    </b>
                                                                }
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>DX Username</strong> <br />
                                                                <b>
                                                                    <p className="text-muted">
                                                                        <span className="text-muted">{userprofile ? userprofile.dx_username : 'NA'}</span>
                                                                    </p>
                                                                </b>
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>Syntellicore UID</strong> <br />
                                                                <b>
                                                                    <p className="text-muted">
                                                                        <span className="text-muted">{ userprofile ? userprofile.syntel_uid : 'NA' }</span>
                                                                    </p>
                                                                </b>
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>Clearing Code</strong> <br />
                                                                <b>
                                                                    <p className="text-muted">
                                                                        <span className="text-muted">{ userprofile ? userprofile.clearing_code : 'NA' }</span>
                                                                    </p>
                                                                </b>
                                                            </div>
                                                        </div>
                                                        <h4 className="mt-2" style={ titleStyle }>
                                                            <b>DEVICE INFORMATION</b>
                                                        </h4>
                                                        <hr />
                                                        <div className="p-20" style={ boxStyle }>
                                                            <div className="about-info-p">
                                                                <strong>Device Type</strong> <br />
                                                                {
                                                                    userprofile && userprofile.device_type === 0 ? 
                                                                    <b>
                                                                        <p className="text-success"><i class="zmdi zmdi-android"></i></p>
                                                                    </b> : (userprofile && userprofile.device_type === 1) ? 
                                                                    <b>
                                                                        <p className="text-black"><i class="zmdi zmdi-apple"></i></p>
                                                                    </b> : 
                                                                    <b>
                                                                        <p className="text-danger">NOT AVAILABLE</p>
                                                                    </b>
                                                                }
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>Device Token</strong> <br />
                                                                <p className="text-muted" style={{ overflowWrap: 'anywhere' }}>
                                                                    {
                                                                        userprofile && userprofile.device_token ? 
                                                                            <b>
                                                                                <span className="text-muted">{userprofile.device_token}</span>
                                                                            </b> : 
                                                                            <b>
                                                                                <span className="text-muted">NOT AVAILABLE</span>
                                                                            </b>
                                                                    }
                                                                </p>
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>UUID</strong> <br />
                                                                <b>
                                                                    <p className="text-muted">
                                                                        <span className="text-muted">{ userprofile ? userprofile.uuid : 'NA' }</span>
                                                                    </p>
                                                                </b>
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>OS Version</strong> <br />
                                                                <b>
                                                                    <p className="text-muted">
                                                                        <span className="text-muted">{ userprofile ? userprofile.os_version : 'NA' }</span>
                                                                    </p>
                                                                </b>
                                                            </div>
                                                            <div className="about-info-p">
                                                                <strong>Model Name</strong> <br />
                                                                <b>
                                                                    <p className="text-muted">
                                                                        <span className="text-danger">{ userprofile ? userprofile.model_name : 'NA' }</span>
                                                                    </p>
                                                                </b>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}